<template>
  <div>
    <div v-if="!success" class="col-sm-12 col-lg-5 mx-auto pb-4">
      <b-overlay :show="loading" rounded="sm">
        <h4 class="text-black font-weight-bold">Riepilogo e Conferma</h4>
        <div class="pt-4">
          <h5 class="text-black text-left py-2">La tua prenotazione:</h5>
          <div class="text-justify">
            <p>
              Stai richiedendo un consulto con il
              {{ this.prenotazione.professionista_tipo }}
              <span class="text-secondary">{{
                this.prenotazione.professionista_nome
              }}</span>
              relativamente alla problematica da te individuata come
              <span class="text-secondary">{{
                this.prenotazione.questionario_nome
              }}</span>
              in data:
            </p>
            <br />
            <h4 class="text-secondary">
              {{ this.prenotazione.data_inizio | moment("LLLL") }}
            </h4>
            <br />
            <p>
              Seleziona "conferma" per richiedere la tua prenotazione oppure
              "indietro" per modificare la data.
            </p>
          </div>
          <br />
        </div>
        <div>
          <b-button
            variant="outline-primary font-weight-bold"
            @click="indietro"
            class="mr-4"
            >indietro</b-button
          >
          <b-button variant="primary font-weight-bold" @click="conferma"
            >Conferma</b-button
          >
        </div>
      </b-overlay>
    </div>

    <div v-else class="col-sm-12 col-lg-5 mx-auto pb-4">
      <h4>Operazione effettuata con successo!</h4>
      <p class="text-justify">
        Grazie per aver prenotato. Riceverai una conferma quando
        {{ this.prenotazione.professionista_nome }} confermerà l'appuntamento
      </p>
      <br />
      <b-button
        block
        variant="primary font-weight-bold rounded-pill"
        @click="backHome"
        >Ok</b-button
      >
    </div>
  </div>
</template>
<script>
// import moment from "moment";
export default {
  name: "step-quattro",
  props: ["prenotazione"],
  data() {
    return {
      loading: false,
      success: false,
    };
  },
  methods: {
    conferma() {
      this.loading = true;
      var url = process.env.VUE_APP_VERSION + "consulto";
      var data = {
        professionista_tipo: this.prenotazione.professionista_tipo,
        professionista_rif: this.prenotazione.professionista_rif,
        data_inizio: this.prenotazione.data_inizio,
        data_fine: this.prenotazione.data_fine,
        settimana: this.prenotazione.settimana,
      };
      this.$axios
        .post(url, data)
        .then((res) => {
          // console.log(res.data.data);
          var rif = res.data.data.hashid;
          if (this.prenotazione.questionario_rif != null) {
            return this.saveConsultoRif(rif);
          } else {
            this.loading = false;
            this.success = true;
          }
        })
        .catch(() => {
          //   this.$router.go();
          // this.msg = true;
        });
    },
    saveConsultoRif(rif) {
      var url = process.env.VUE_APP_VERSION + "paziente/questionario";
      var data = {
        consulto_rif: rif,
        questionario_rif: this.prenotazione.questionario_rif,
      };
      this.$axios
        .put(url, data)
        .then((res) => {
          // console.log(res.data.data);
          this.loading = false;
          this.success = true;
        })
        .catch(() => {
          //   this.$router.go();
          // this.msg = true;
        });
    },
    indietro() {
      this.$emit("remove-index");
    },
    backHome() {
      this.$router.push({ name: "Home" });
    },
  },
};
</script>
